import { jsx as r } from "react/jsx-runtime";
import * as L from "react";
function f(t) {
  return /* @__PURE__ */ r(
    "svg",
    {
      "data-testid": "bookie-logo-fallback",
      fill: "none",
      height: t.height,
      viewBox: "0 0 70 70",
      width: t.width,
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      children: /* @__PURE__ */ r(
        "path",
        {
          clipRule: "evenodd",
          d: "M67.6176 14.3489H44.9139C47.3722 12.6837 48.8339 10.7984 49.3275 8.68334C49.8127 6.23359 49.0171 3.70418 47.2203 1.98415C47.1634 1.9363 47.0969 1.89802 47.04 1.85017C46.9831 1.80232 46.9451 1.73533 46.8881 1.68748C44.9745 0.078467 42.3728 -0.420856 40.0068 0.36678C37.7858 1.18025 35.9729 3.12302 34.5586 6.25249C33.1349 3.12302 31.3315 1.18025 29.1105 0.36678C26.7444 -0.420856 24.1428 0.078467 22.2292 1.68748C22.1722 1.73533 22.1247 1.79275 22.0773 1.85017C22.0298 1.90759 21.9539 1.9363 21.8969 1.98415C20.1002 3.70418 19.3046 6.23359 19.7898 8.68334C20.2834 10.7984 21.7451 12.6741 24.2034 14.3489H2.37288C1.06238 14.3489 0 15.4201 0 16.7415V31.6233C0 32.9446 1.06238 34.0158 2.37288 34.0158H4.9261V67.6074C4.9261 68.9288 5.98848 70 7.29898 70H62.701C64.0115 70 65.0739 68.9288 65.0739 67.6074V34.0158H67.6271C68.9376 34.0158 70 32.9446 70 31.6233V16.7415C70 16.1053 69.7487 15.4953 69.3017 15.0463C68.8546 14.5973 68.2486 14.3464 67.6176 14.3489ZM39.4097 19.1341V29.2307H29.3867V19.1341H39.4097ZM41.6026 4.8455C42.3777 4.63223 43.2071 4.80662 43.8331 5.31444L43.9185 5.37186L43.9944 5.458C44.5437 6.01777 44.8064 6.80163 44.7063 7.58259C44.545 8.26208 43.5294 10.4537 37.3694 12.7792C38.945 6.39588 40.9572 5.09433 41.6026 4.8455ZM27.5169 4.84588C28.1718 5.0947 30.1745 6.39626 31.7501 12.7892C25.6375 10.4636 24.5935 8.30074 24.4226 7.62125C24.3001 6.81919 24.5687 6.00679 25.144 5.43923L25.2104 5.36267L25.2864 5.31482C25.913 4.80845 26.7417 4.63421 27.5169 4.84588ZM4.73433 19.1341H24.6381V29.2307H4.78179L4.73433 19.1341ZM9.70107 34.016H24.6407V65.2151H9.70107V34.016ZM29.3867 65.2151V34.016H39.4097V65.2151H29.3867ZM60.3274 65.2151H44.1918V34.016H60.3274V65.2151ZM65.245 29.2307H44.1548V19.1341H65.245V29.2307Z",
          fill: "#9DAFBD",
          fillRule: "evenodd"
        }
      )
    }
  );
}
const l = {};
var m = /* @__PURE__ */ ((t) => (t.LARGE = "large", t.SMALL = "small", t))(m || {});
const w = ({
  bookieCode: t,
  bookmakers: g,
  className: a = "",
  noPadding: n = !1,
  onClick: s,
  size: e,
  testId: d = "bookie-logo",
  withBackground: c = !0
}) => {
  const [i, H] = L.useState(!1), o = g[`${t}`], C = e === "large" ? o == null ? void 0 : o.logoLarge : o == null ? void 0 : o.logoSmall, V = (o == null ? void 0 : o.brandColour) && C;
  if (i || !V) {
    const u = e === "large" ? 190 : 40, h = e === "large" ? 50 : 40;
    return /* @__PURE__ */ r(
      f,
      {
        className: [l.bookieLogo, n ? l.noPadding : "", a].join(" "),
        height: h,
        width: u
      }
    );
  }
  return /* @__PURE__ */ r(
    "img",
    {
      alt: `${o == null ? void 0 : o.bookmakerName} logo`,
      className: [l.bookieLogo, n ? l.noPadding : "", a].join(" "),
      "data-testid": d,
      onClick: s,
      onError: () => {
        H(!0);
      },
      src: C,
      style: { background: c ? o == null ? void 0 : o.brandColour : "" }
    }
  );
};
export {
  m as LOGO_SIZE,
  w as default
};
